import { useParams } from "react-router-dom";
import { OrderParams } from "./OrderPage";
import Crumb from "features/breadcrumbs/Crumb";

const OrdersCrumb: React.FC = () => {
  const { orderId } = useParams<OrderParams>();

  return <Crumb to={`/orders/view/${orderId}`}>{orderId}</Crumb>;
};

export default OrdersCrumb;
